export enum Budget {
	LOW = 5,
	MIDDLE = 10,
	HIGH = 20,
}
